// app/layout/footer/footer.component.ts
import { Component, inject, afterNextRender } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { Article, NewsService } from '../../core/updates/updates.service';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

interface FooterLink {
  id: number;
  title?: string;
  ariaLabel?: string;
  url: string;
}

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [MatDividerModule, RouterLink, MatButton, MatIcon,CommonModule],
  templateUrl:'./footer.html',
  styleUrl: './footer.scss'
})
export class FooterComponent {
  year = new Date().getFullYear();
  private readonly news = inject(NewsService);
  articles: Pick<Article, 'slug' | 'title'>[] = [];
  footerLinks: FooterLink[] = [
    { id: 3, title: 'Termeni & Conditii', url: '/docs/terms' },
    { id: 4, title: 'Protectia Datelor', url: '/docs/privacy' },
    { id: 5, title: 'Politica de Cookies', url: '/docs/cookie' },
    { id: 6, title: 'Politica de Stergere', url: '/docs/datadeletion' },
  ];

  anpc: FooterLink[] = [
    { id: 1, ariaLabel: 'Soluționare Alternativă Litigii', url: 'https://anpc.ro/ce-este-sal/'},
    { id: 2, ariaLabel: 'Online Dispute Resolution', url: 'https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO'},
  ];

  constructor() {
    // Defer Firestore query until after first render — keeps it out of SSR and LCP critical path.
    afterNextRender(() => {
      this.news.list().then(list => {
        this.articles = list.slice(0, 4).map(a => ({ slug: a.slug, title: a.title }));
      });
    });
  }
}
